// components/SelectedItemsPDFView.jsx

import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

const SelectedItemsPDFView = React.forwardRef(({ items, salonInfo }, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        p: 4,
        fontFamily: "Arial",
        width: "100%",
        color: "#000",
        backgroundColor: "#fff",
      }}
    >
      {/* Header */}
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" sx={{ color: "#002366", fontWeight: "bold" }}>
          {salonInfo?.name}
        </Typography>
        <Typography>{salonInfo?.address}</Typography>
        <Typography sx={{ fontWeight: "bold", color: "#002366" }}>
          PH-NO : {salonInfo?.phone}
        </Typography>
        <Typography sx={{ fontWeight: "bold", color: "#002366" }}>
          Email : {salonInfo?.email || "Palacethesalon@gmail.com"}
        </Typography>
      </Box>

      {/* Table */}
      <Table>
        <TableHead>
          <TableRow sx={{ borderBottom: "3px solid black" }}>
            <TableCell sx={{ fontWeight: "bold", color: "#002366" }}>
              ITEM
            </TableCell>
            <TableCell sx={{ fontWeight: "bold", color: "#002366" }}>
              PRICE
            </TableCell>
            <TableCell sx={{ fontWeight: "bold", color: "#002366" }}>
              DISC. PRICE
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((item, idx) => (
            <TableRow
              key={idx}
              sx={{ borderBottom: "3px solid black"}}
            >
              <TableCell sx={{ fontWeight: "500" }}>
                {item.itemDescription || "N/A"}
              </TableCell>
              <TableCell sx={{ fontWeight: "500" }}>
                {parseFloat(item.mrp || 0).toFixed(2)}
              </TableCell>
              <TableCell sx={{ fontWeight: "500" }}>
                {parseFloat(item.discountPrice || item.price || 0).toFixed(2)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
});

export default SelectedItemsPDFView;
